<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-card class="mt-2 col-12">
        <b-col cols="12">
          <SearchFilter @handleSubmit="searchFilterSubmit" :mode="'History'" />
        </b-col>
      </b-card>

      <b-card>
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="'History'"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import * as userData from "@/auth/localStorageUtils.js";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    BOverlay,
  },
  data() {
    return {
      showOverlay: false,
      tableHeader: commonTableHeader,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    searchFilterSubmit(params) {
      params.departmentId = userData.departmentId();
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "MasterPurchaseManage",
          query: { masterTypeId },
        }).href,
        "_blank"
      );
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      const routeData = this.$router.resolve({
        name: "ComplaintHistoryDetail",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
